import {useEffect, useState} from 'react';
import {
  Box,
  Radio,
  RadioGroup,
  FormControlLabel,
  Avatar,
  Grid,
  Checkbox,
} from '@material-ui/core';
import CircleIcon from '@mui/icons-material/Circle';
import {IconProfile} from '../../assets';
import '../../assets/styles/checkBoxSelection.scss';

function CheckBoxPkCodeSelection(props) {
  const [data, setData] = useState(props.data);

  // const filteredArray = data.filter((item) =>
  //   item.name.toLowerCase().includes(props.search.toLowerCase())
  // );

  const handleChange = (event) => {
    // const {id} = event.target;
    // setData(
    //   data.map((item) =>
    //     item.id === id ? {...item, checked: !item.checked} : item
    //   )
    // );
  };

  return (
    <Grid container spacing={2} className='check_box_selection_container'>
      {props.data.map((option) => (
        <Grid item xs={12} sm={6} md={4} lg={4} key={option.label}>
          <div
            style={{
              background: '#2B5180',
              color: ' white',
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              borderRadius: '15px',
            }}
          >
            <div
              style={{
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                padding: '10px',
              }}
            >
              <div className='check_box_selection_text pk_code'>
                <div className='top_text'>{option.namaKawasan}</div>
                <div className='bottom_text'>{option.kodKawasan}</div>
              </div>
            </div>
            <div
              style={{
                backgroundColor: '#3A5C86',
                padding: '14px 7px',
                borderRadius: '0 10px 10px  0 ',
              }}
            >
              <Checkbox
                checked={props.payload.pk_codes.includes(option.kodKawasan)}
                onChange={(e) => {
                  props.onSelectionChange(e, option);
                }}
                key={option.kodKawasan}
                icon={
                  <CircleIcon
                    style={{color: 'white', width: '20px', height: '20px'}}
                  />
                }
                name={props.name}
                checkedIcon={
                  <CircleIcon
                    style={{
                      color: 'blue',
                      border: 'white 5px solid',
                      borderRadius: '50%',
                      width: '20px',
                      height: '20px',
                    }}
                  />
                }
                color='primary'
                shape='circle'
              />
            </div>
          </div>
        </Grid>
      ))}
    </Grid>
  );
}

export default CheckBoxPkCodeSelection;
